var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/utils/getExplorerFolderIcon.tsx";
import { Folder, FolderEmpty } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var getExplorerFolderIcon = function getExplorerFolderIcon(isEmpty) {
  return isEmpty ? /*#__PURE__*/_jsx(FolderEmpty, {}) : /*#__PURE__*/_jsx(Folder, {});
};